export function convertHalfToFull(str: string): string {
  return str.replace(/[A-Za-z]/g, s =>
    String.fromCharCode(s.charCodeAt(0) + 0xfee0),
  );
}

export function convertJaSmallToLarge(str: string): string {
  const map: Record<string, string> = {
    ぁ: 'あ',
    ぃ: 'い',
    ぅ: 'う',
    ぇ: 'え',
    ぉ: 'お',
    っ: 'つ',
    ゃ: 'や',
    ゅ: 'ゆ',
    ょ: 'よ',
    ゎ: 'わ',
    ァ: 'ア',
    ィ: 'イ',
    ゥ: 'ウ',
    ェ: 'エ',
    ォ: 'オ',
    ヵ: 'カ',
    ヶ: 'ケ',
    ッ: 'ツ',
    ャ: 'ヤ',
    ュ: 'ユ',
    ョ: 'ヨ',
    ヮ: 'ワ',
  };

  return str.replace(/[\u3041-\u3096\u30A1-\u30FA]/g, s =>
    s in map ? map[s] : s,
  );
}

/**
 * 値が空でない文字列である場合のみ true を返す型ガード。
 * FileReader.result（string | ArrayBuffer | null）のような union 型から string に絞り込む用途を想定。
 *
 * @param value 判定対象の値
 * @returns 空でない文字列なら true（型は string に絞り込まれる）
 */
export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value !== '';
}
